import { favoriteTemplate } from '../modules/candidateModule';

export default {
    state: {
        favorites: {},

        activeFavorites: [],
        expiredFavorites: [],
        activePage: 1,
        expiredPage: 1,
        activeTotalCount: 0,
        expiredTotalCount: 0,
        hasNextActivePage: true,
        hasNextExpiredPage: true,
    },
    getters: {
        getActiveFavorites: state => payload =>
            state.activeFavorites.map(id => state.favorites[id]),
        getExpiredFavorites: state => payload =>
            state.expiredFavorites.map(id => state.favorites[id]),
        getActivePage: state => payload => state.activePage,
        getExpiredPage: state => payload => state.expiredPage,
        getActiveTotalCount: state => payload => state.activeTotalCount,
        getExpiredTotalCount: state => payload => state.expiredTotalCount,
        getHasNextActivePage: state => payload => state.hasNextActivePage,
        getHasNextExpiredPage: state => payload => state.hasNextExpiredPage,
    },
    mutations: {
        appendActiveFavorites(state, favorites) {
            favorites.forEach(fav => {
                if (!state.favorites[fav.id]) {
                    state.activeFavorites.push(fav.id);
                    state.favorites[fav.id] = favoriteTemplate(fav);
                }
            });

            // state.activeFavorites.push(...favorites.map(favoriteTemplate));
        },
        appendExpiredFavorites(state, favorites) {
            favorites.forEach(fav => {
                if (!state.favorites[fav.id]) {
                    state.expiredFavorites.push(fav.id);
                    state.favorites[fav.id] = favoriteTemplate(fav);
                }
            });

            // state.expiredFavorites.push(...favorites.map(favoriteTemplate));
        },
        activePageIncrement(state) {
            state.activePage++;
        },
        expiredPageIncrement(state) {
            state.expiredPage++;
        },
        reset(state) {
            state.favorites = {};
            state.activePage = 1;
            state.expiredPage = 1;
            state.activeFavorites = [];
            state.expiredFavorites = [];
        },
        setHasNextActivePage(state, value) {
            state.hasNextActivePage = Boolean(value);
        },
        setHasNextExpiredPage(state, value) {
            state.hasNextExpiredPage = Boolean(value);
        },

        setActiveTotalCount(state, value) {
            state.activeTotalCount = Number(value);
        },
        setExpiredTotalCount(state, value) {
            state.expiredTotalCount = Number(value);
        },
    },
};
